<template>
  <form @submit.prevent="submit">
    <b-row>
      <!--Column 1-->
      <b-col sm="6">
        <b-form-group label="Exportadora">
          <b-form-select
            :disabled="disabledform"
            id="client"
            :state="
              $v.processData.client_customer.$dirty
                ? !$v.processData.client_customer.$error
                : null
            "
            v-model="$v.processData.client_customer.$model"
            :options="customers"
          />
          <b-form-invalid-feedback id="input-1-live-feedback">
            Este campo es requerido.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Empresa">
          <b-form-select
            :disabled="disabledform"
            id="company"
            :state="
              $v.processData.company.$dirty
                ? !$v.processData.company.$error
                : null
            "
            v-model="$v.processData.company.$model"
            :options="companies"
          />
        </b-form-group>

        <b-form-group label="Origen">
          <b-form-select
            :disabled="disabledform"
            id="origin"
            :state="
              $v.processData.origin.$dirty
                ? !$v.processData.origin.$error
                : null
            "
            v-model="$v.processData.origin.$model"
            :options="origins"
          />
        </b-form-group>
      </b-col>

      <!--Column 2-->
      <b-col sm="6">
        <b-form-group label="Producto*">
          <b-form-select
            :disabled="disabledform"
            id="product"
            :state="
              $v.processData.product.$dirty
                ? !$v.processData.product.$error
                : null
            "
            v-model="$v.processData.product.$model"
            @change="getProductSet"
            :options="products"
          />
          <b-form-invalid-feedback id="input-1-live-feedback">
            Este campo es requerido.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Variedad">
          <b-form-select
            :disabled="disabledform"
            id="variety"
            :state="
              $v.processData.variety.$dirty
                ? !$v.processData.variety.$error
                : null
            "
            v-model="$v.processData.variety.$model"
            :options="varieties"
          />
        </b-form-group>

        <b-form-group label="Condición">
          <b-form-select
            :disabled="disabledform"
            id="condition"
            :state="
              $v.processData.condition.$dirty
                ? !$v.processData.condition.$error
                : null
            "
            v-model="$v.processData.condition.$model"
            :options="conditions"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { required, minLength, between } from "vuelidate/lib/validators";

export default {
  name: "ProcesoForm",
  props: ["disabledform", "processData"],
  data() {
    return {
      // Options dropdown
      customers: [],
      origins: [],
      companies: [],
      varieties: [],
      conditions: [
        { text: "Convencional", value: "Convencional" },
        { text: "Orgánico", value: "Orgánico" },
        { text: "Org. System Approach", value: "Org. System Approach" },
      ],
      products: []
    };
  },
  validations: {
    processData: {
      client_customer: { required },
      variety: { required },
      origin: { required },
      condition: { required },
      company: { required },
      product: { required }
    }
  },
  mounted() {
    this.getCustomers();
    //668 de frigorifico
    //18 en mi local
    this.processData.client_customer = 668;
  },
  computed: {
    client_customer() {
      return this.processData.client_customer;
    },
    // product() {
    //   return this.processData.product;
    // },
    company() {
      return this.processData.company;
    }
  },
  watch: {
    // product: {
    //   handler(val) {
    //     this.getProductSet(this.product);
    //   }
    // },
    company: {
      handler(val) {
        this.getCompanyFacilities(this.company);
      }
    },
    client_customer: {
      handler(val) {
        this.company = null;
        this.getCompanies(this.client_customer);
        this.getProducts(this.client_customer);
      }
    }
  },
  methods: {
    getProducts(client_customer) {
      this.$axios
        .get("/production/get_products_company/" + client_customer)
        .then((res) => {
          const data = res.data.data;
          const products = [];
          for (let key in data) {
            const product = data[key];
            products.push(product);
          }

          this.products = products;
        })
        .catch((error) => console.log(error));
    },
    getCompanyFacilities(a) {
      this.$axios
        .get("/production/get_company_facilities/" + a)
        .then((res) => {
          this.origins = res.data.origins;
          this.$emit("origins", this.origins);
        })
        .catch((error) => {
          this.disabled_inputs.plants = true;
        });
    },
    getCustomers() {
      this.$axios
        .get("/production/get_customers/")
        .then((res) => {
          this.customers = res.data.data;
        })
        .catch((error) => console.log(errors));
    },
    getCompanies(a) {
      this.$axios
        .get("/production/get_companies/" + a + "/")
        .then((res) => {
          this.companies = res.data.data;
        })
        .catch((error) => console.log(errors));
    },
    getProductSet(a) {
      this.$axios
        .get("/production/get_product_set/" + a)
        .then((res) => {
          this.varieties = res.data.varieties;
        })
        .catch((error) => (this.selected.product_type = ""));
    },

    // Validation methods
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      };
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$emit("validate", false);
      } else {
        // do your submit logic here
        this.$emit("validate", true);
      }
    }
  }
};
</script>

<style scoped></style>
